<script>
    export let data;
    let modifiedData;
    if(data) {
        modifiedData = data.bold();
    }
</script>

{@html modifiedData}